interface Props {
  /** Visual size preset. `sm` (default, sidebar) or `lg` (hero/login). */
  size?: 'sm' | 'lg';
}

export default function Logo({ size = 'sm' }: Props) {
  const large = size === 'lg';
  return (
    <div className={`flex items-center ${large ? 'gap-1.5' : 'gap-0.5'}`}>
      <img
        src="/logo.png"
        alt="5C Network"
        className={`w-auto shrink-0 select-none block ${large ? 'h-12' : 'h-7'}`}
        draggable={false}
      />
      <span
        className={`text-fg font-semibold tracking-tight-plus select-none leading-none ${
          large ? 'text-[22px]' : 'text-[14px]'
        }`}
      >
        Network
      </span>
    </div>
  );
}
